const saveDomainGym = () => {};

export default saveDomainGym;
